import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Vision", id: "vision" },
  { label: "Why Khadi", id: "why" },
  { label: "Impact", id: "impact" },
  { label: "Challenge", id: "challenge" },
  { label: "Knowledge", id: "knowledge" },
  { label: "Partners", id: "partners" },
  { label: "Finale", id: "finale" },
];

export const Nav = ({ ready }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80 }}
      animate={{ y: ready ? 0 : -80 }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-[9000] transition-colors duration-500 ${
        scrolled ? "backdrop-blur-2xl bg-[#f2ece0]/70 border-b border-black/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={`font-serif text-xl md:text-2xl tracking-tight ${scrolled ? "text-[#2a2018]" : "text-[#f2ece0]"} transition-colors duration-500`}
        >
          Khadi<span className="text-[#a65a34]">.</span>
          <span className="font-display text-[9px] tracking-[0.35em] uppercase ml-2 align-middle opacity-70">Fashion Icon India</span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className={`font-display text-[11px] uppercase tracking-[0.18em] transition-opacity duration-300 hover:opacity-50 ${
                scrolled ? "text-[#2a2018]" : "text-[#f2ece0]"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-register-btn"
            onClick={() => go("challenge")}
            className={`btn-invert hidden sm:inline-flex items-center px-6 py-2.5 font-display text-[11px] uppercase tracking-[0.18em] border ${
              scrolled
                ? "border-[#2a2018] text-[#2a2018] hover:text-[#f2ece0]"
                : "border-[#f2ece0] text-[#f2ece0] hover:text-[#f2ece0]"
            } transition-colors duration-300`}
          >
            <span className="fill" />
            Register
          </button>
          <button
            data-testid="nav-menu-toggle"
            className={`lg:hidden ${scrolled ? "text-[#2a2018]" : "text-[#f2ece0]"}`}
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="lg:hidden bg-[#1a130b] overflow-hidden"
        >
          <div className="flex flex-col px-6 py-6 gap-4">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left font-serif text-2xl text-[#f2ece0]"
              >
                {l.label}
              </button>
            ))}
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Nav;
